import { render, staticRenderFns } from "./ViewItem.vue?vue&type=template&id=787754b7&scoped=true&"
import script from "./ViewItem.vue?vue&type=script&lang=ts&"
export * from "./ViewItem.vue?vue&type=script&lang=ts&"
import style0 from "./ViewItem.vue?vue&type=style&index=0&id=787754b7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "787754b7",
  null
  
)

export default component.exports